import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { CasinoTheme } from '@frontend/casino-ui/shared';
import { DslPipe } from '@frontend/vanilla/core';

import { PillItemComponent } from '../pill-item.component';
import { IExtendedTopMenuItem } from '../pill-sub-navigation.component';
import { PillSubNavConfig } from '../pills-sub-navigation.model';

@Component({
    selector: 'cc-mobile-navigation',
    standalone: true,
    imports: [AsyncPipe, DslPipe, PillItemComponent],
    templateUrl: './mobile-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileNavigationComponent {
    config = input<PillSubNavConfig>({} as PillSubNavConfig);
    extendTopMenuState = input<boolean>(false);
    extendTopMenu = input<IExtendedTopMenuItem[]>([]);
    currentTheme = input<CasinoTheme>('bwin');

    readonly goToUrl = output<string>();

    handleGoToUrl(url: string): void {
        this.goToUrl.emit(url);
    }
}
